/**
 This hook will only work if the helpcenterId exists in the path param and the activation-id exists in the meta tag.
 @returns {string} The Help Center ARI.
 */

import { getMeta } from '@helpcenter/meta';
import { usePathParam } from 'react-resource-router';
// eslint-disable-next-line no-restricted-imports
import { HelpHelpCenterAri } from '@atlassian/ari';

export const useHelpCenterAri = () => {
    const [helpCenterId = ''] = usePathParam('helpcenterId');
    const activationId = getMeta('activation-id') || '';

    const helpCenterAri = HelpHelpCenterAri.create({ activationId, helpCenterId }).toString();
    return helpCenterAri;
};
